export function Logo({ size = 'md', href = '/' }: { size?: 'sm' | 'md' | 'lg'; href?: string }) {
  const sizes: Record<string, { container: string; img: string }> = {
    sm:  { container: 'h-8',  img: 'h-7'  },
    md:  { container: 'h-12', img: 'h-16'  },
    lg:  { container: 'h-15', img: 'h-15' },
  };
  const s = sizes[size];
  const logoSrc = '/images/logo.svg';

  return (
    <a href={href} className={`flex items-center gap-2 ${s.container} shrink-0 no-underline`}>
      <img
        src={logoSrc}
        alt="Beyond Silence"
        width={195}
        height={195}
        className={`${s.img} w-auto`}
        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
      />
    </a>
  );
}
